import uniq from 'lodash/uniq';
import { Fragment } from 'react/jsx-runtime';

import { Locales, Person, Photo, PhotoLocation } from '@types';

export const capitalize = (str: string) =>
  `${str.charAt(0).toUpperCase()}${str.slice(1)}`;

export const formatLocation = (
  { detail, city, region, country }: PhotoLocation,
  withoutDetail?: boolean,
) => {
  const parts = (
    withoutDetail ? [city, region, country] : [detail, city, region, country]
  ).filter((part) => !!part);
  return uniq(parts).join(', ');
};

export const formatPhotoName = ({ location, name }: Photo) => {
  const locationStr =
    typeof location === 'string' ? location : formatLocation(location);
  return `${name ? `${name} - ` : ''}${locationStr}`;
};

export const formatDate = (
  d: Date | string,
  locale: Locales,
  options?: Intl.DateTimeFormatOptions,
) => {
  const date = typeof d === 'string' ? new Date(d) : d;
  return date
    .toLocaleString(
      locale === Locales.FR ? 'fr-FR' : 'en-UK',
      options || {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
      },
    )
    .replaceAll('.', '');
};

export const formatStartEndDates = (
  start: Date,
  end: Date,
  locale: Locales,
) => {
  const sameMonth = start.getMonth() === end.getMonth();
  const sameYear = start.getFullYear() === end.getFullYear();

  if (sameYear) {
    const startDate = formatDate(start, locale, {
      month: sameMonth ? 'long' : 'short',
      year: sameMonth ? 'numeric' : undefined,
    });
    const endDate = formatDate(end, locale, {
      month: 'short',
      year: 'numeric',
    });
    return `${startDate}${!sameMonth ? ` — ${endDate}` : ''}`;
  } else {
    const startDate = formatDate(start, locale, { year: 'numeric' });
    const endDate = formatDate(end, locale, { year: 'numeric' });
    return `${startDate} - ${endDate}`;
  }
};

export const renderPeople = (people: Person[]) =>
  people.map(({ name, link }, index) => (
    <Fragment key={name}>
      {link ? (
        <a
          className="text-accent hover:border-b text-nowrap"
          href={link}
          target="_blank"
        >
          {name}
        </a>
      ) : (
        <span className="text-nowrap">{name}</span>
      )}
      {index < people.length - 2 ? (
        <span>{', '}</span>
      ) : index < people.length - 1 ? (
        <span>{' & '}</span>
      ) : null}
    </Fragment>
  ));
